

<template>        
    <v-card v-if="tokens.length > 0">
        <v-card-title>
            <h2>
                Authorized Applications
            </h2>
        </v-card-title>

        <v-card-text>
            <!-- Authorized Tokens -->
            
            <v-layout>
                <v-flex xs6 offset-xs6>
                    <v-text-field
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                        v-model="tsearch"
                        >
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-data-table 
                    v-if="tokens.length > 0"
                    v-bind:headers="headers"
                    v-bind:items="tokens"
                    v-bind:search="tsearch"
                    select-all
                    v-bind:pagination.sync="pagination"
                    item-key="id"
                    class="elevation-0"
                    >
                
                    <template slot="headers" slot-scope="props">
                   
                        <tr>
                           
                            <th 
                                align="left"
                                v-for="header in props.headers" 
                                :key="header.text"
                                :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                                @click="changeSort(header.value)"
                            >
                            <v-icon>arrow_upward</v-icon>
                                {{ header.text }}
                            </th>
                            <th></th>
                        </tr>
                    </template>
                    <template slot="items" slot-scope="props">
                        <tr>                            
                            
                            
                            <td>
                                {{ props.item.client.name }}
                            </td>
                            <td>
                                {{ props.item.client.uid }}
                            </td>
                            <td>
                                {{ props.item.client.scopes }}
                            </td>
                            
                            <td>
                                <v-btn small class="error" v-on:click.native.stop="revoke(props.item)">
                                    Revoke
                                </v-btn>
                            </td>
                        </tr>
                    </template>                   
                </v-data-table>
            
        </v-card-text>
    </v-card>
 
</template>

<script>

    export default {
        /*
         * The component's data.
         */
        data() {
            return {
                pagination: {
                    sortBy: 'name'
                },
                tsearch:'',                
                headers: [
                    {text: 'Name', align: 'left', value: 'client.name'},
                    {text: 'Uid', align: 'left', value: 'client.uid'},
                    {text: 'Sopes', align: 'left', value: 'client.scopes'},
                ],
                tokens: []
            };
        },
        

        /**
         * Prepare the component (Vue 2.x).
         */
        mounted() {
            this.prepareComponent();
        },

        methods: {
            /**
             * Data table methods.
             */

            changeSort (column) {
                if (this.pagination.sortBy === column) {
                  this.pagination.descending = !this.pagination.descending
                } else {
                  this.pagination.sortBy = column
                  this.pagination.descending = false
                }              
            },
            /**
             * Prepare the component (Vue 2.x).
             */
            prepareComponent() {
                this.getTokens();
            },

            /**
             * Get all of the authorized tokens for the user.
             */
            getTokens() {
                this.$store.dispatch('getClientTokens').then((response)=>{                
                    this.tokens = response.data;
                })                                            
            },

            /**
             * Revoke the given token.
            */ 
            revoke(token) {
                this.$store.dispatch('deleteClientTokens',token.id).then((response)=>{                
                    this.getTokens();
                })                 
            }
        }
    }
</script>



// WEBPACK FOOTER //
// AuthorizedClients.vue?4e3596c7